import Reimbursement from "../../../../components/company/expense/reimbursement-claims";

export default function ReimbursementPage() {
  return (<Reimbursement />);
}
